import { useApiData } from 'lib/api';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { LoadingIndicator, Owners, TitleWithIcon } from 'components/common';
import { Box, BoxEmpty } from 'components/common/box';

interface Props {
  targetUserId: number;
}

const ProfileSummaryGroups = ({ targetUserId }: Props) => {
  const { messages, user } = useReduxState();

  const { data, loading } = useApiData({
    url: `/admin/users/${targetUserId}/groups`,
    onlyIf: Boolean(targetUserId)
  });

  const groups = data?.groups;

  return (
    <Box title={messages.commonGroups}>
      {loading ? (
        <LoadingIndicator />
      ) : groups && groups.length ? (
        <div className="groups-container">
          {groups.map((group) => (
            <div className="group" key={group.id}>
              <TitleWithIcon
                icon="users"
                title={group.title}
                titleLink={
                  user?.roles.includes('admin')
                    ? {
                        as: `/groups/${group.id}`,
                        href: '/groups/[groupId]'
                      }
                    : null
                }
              >
                <Owners owners={group.owners} />
              </TitleWithIcon>
            </div>
          ))}
        </div>
      ) : (
        <BoxEmpty align="center" text={messages.groupsEmpty} />
      )}

      <style jsx>{`
        .groups-container {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -10px 0;
        }
        .group {
          width: 100%;
          padding: 10px;
        }
        @media (min-width: ${breakpoints.small}px) {
          .group {
            width: 50%;
          }
        }
        @media (min-width: ${breakpoints.large}px) {
          .group {
            width: 33.333%;
          }
        }
      `}</style>
    </Box>
  );
};

export default ProfileSummaryGroups;
